import { put, takeLatest } from 'redux-saga/effects';

import { apiCall, ApiResult } from 'Modules/core/api';

import { emissionActions } from './actions';
import { emission } from '../../api';


function* setEmissionsLoading(isLoading: boolean) {
    yield put(emissionActions.setEmissionLoading(isLoading));
}

function* getEmissions() {
    try {
        yield setEmissionsLoading(true);

        const emissions: ApiResult<typeof emission.list> = yield apiCall(emission.list);

        yield put(emissionActions.setEmissionItems(emissions));
    } catch (error) {
        yield put(emissionActions.setEmissionError(error));
    }

    yield setEmissionsLoading(false);
}

export const sagas = [takeLatest(`${emissionActions.getEmissions}`, getEmissions)];
